export default function CaseStudy() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Кейс: как программа обучения изменила компанию
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Реальный проект разработки и внедрения корпоративной программы обучения для производственной компании
        </p>

        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-100">
          <div className="grid md:grid-cols-2 gap-8 mb-10">
            <div>
              <h3 className="text-lg font-bold text-red-600 mb-4 flex items-center gap-2">
                <i className="ri-error-warning-line"></i> Проблема
              </h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  <span>Текучесть персонала 32% в первый год работы</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  <span>Адаптация новичков занимала 3+ месяца</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  <span>Ключевые клиенты жаловались на нестабильное качество</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  <span>Зависимость от 3-4 опытных сотрудников</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-close-circle-line text-red-400 mt-0.5"></i>
                  <span>Руководители перегружены операционкой</span>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold text-teal-600 mb-4 flex items-center gap-2">
                <i className="ri-lightbulb-line"></i> Решение
              </h3>
              <ul className="space-y-3 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  <span>Диагностика компетенций всех сотрудников (120 чел.)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  <span>Разработка трёхуровневой программы: новички → специалисты → руководители</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  <span>Запуск системы наставничества (12 наставников)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  <span>Создание базы знаний: скрипты, чек-листы, видеоуроки</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-0.5"></i>
                  <span>Обучение руководителей управленческим навыкам</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {[
              { metric: '-53%', label: 'Текучесть', sub: 'с 32% до 15%' },
              { metric: '-50%', label: 'Адаптация', sub: 'с 3 до 1.5 мес' },
              { metric: '+68%', label: 'NPS', sub: 'с 28 до 47' },
              { metric: '+22%', label: 'Производительность', sub: 'выпуск продукции' },
            ].map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-5 text-center border border-teal-100">
                <div className="text-2xl md:text-3xl font-extrabold text-teal-600 mb-1 whitespace-nowrap">{item.metric}</div>
                <div className="text-sm font-semibold text-gray-900 mb-1">{item.label}</div>
                <div className="text-xs text-gray-500">{item.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}